import { render, staticRenderFns } from "./petSee.vue?vue&type=template&id=484daeb8&scoped=true&"
import script from "./petSee.vue?vue&type=script&lang=js&"
export * from "./petSee.vue?vue&type=script&lang=js&"
import style0 from "./petSee.vue?vue&type=style&index=0&id=484daeb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484daeb8",
  null
  
)

export default component.exports